import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import './common/core/primitives/time/string.extensions';
import { assignedPermissionsTestData } from './common/user-management/permission-management/permission-groups/data/permission-groups.data';
import { IAccount } from './common/user-management/system-management/accounts/dtos/responses/accounts-list-response';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './trash/shared/components/loader/loader.component';
import { OverlayLoadingSpinnerComponent } from './trash/shared/components/overlay-loading-spinner/overlay-loading-spinner.component';
import { ToastersComponent } from './trash/shared/components/toasters/toasters.component';
import { PublicService } from './trash/shared/services/public.service';
import { NetworkStatusService } from './trash/shared/services/network-status/network-status.service';
import { ActionTypeBaseSmartEnum, ActionTypeHandlerBaseSmartEnum, Logger, UserContextService } from './common';
import { ChangeModeLangService } from './trash/shared/services/change-mode-lang.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TranslateModule,
    OverlayLoadingSpinnerComponent,
    CommonModule,
    ToastersComponent,
    LoaderComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'app';
  isLoadingAction: boolean = false;
  accounts: IAccount[] = [];
  isApplicationAlive = signal(false);

  _NetworkStatusService = inject(NetworkStatusService);

  constructor(
    public translate: TranslateService,
    private _PublicService: PublicService,
    public changeModeLang: ChangeModeLangService,
    titleService: Title
  ) {
    titleService.setTitle('Makani');
    let userContext = UserContextService.getUserContext();
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');

    translate.use('en');
    Logger.info(ActionTypeHandlerBaseSmartEnum);
    Logger.info(ActionTypeBaseSmartEnum);
  }

  ngOnInit(): void {
    this._PublicService.fullPageLoading.subscribe((res: boolean) => {
      this.isLoadingAction = res;
    });

    this.isApplicationAlive.set(true);

    const storedLang = localStorage.getItem('lang') || 'en';
    const dir = storedLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = storedLang;

    this.translate.use(storedLang);

    this.changeModeLang.onThemeChange.subscribe((data) => {
      document.documentElement.dir = data.dir;
      document.documentElement.lang = data.lang;
      this.translate.use(data.lang);
    });
  }

  protected readonly assignedPermissionsTestData = assignedPermissionsTestData;
}
